import { v2ClientOptions } from "@/api/apiClient";
import { type InferRequestType, hc } from "hono/client";
import type { AppType } from "v2-server";
import type { RoadAiJobHandle } from "./roadAi.types";

// `VITE_API_V2_BASE` already includes `/v2/api`; strip it because hc<AppType>
// expects the root the Hono app is mounted on.
const apiRootUrl =
	(import.meta.env.VITE_API_V2_BASE as string | undefined)?.replace(
		/\/v2\/api\/?$/,
		"",
	) ?? "";

const apiClient = hc<AppType>(apiRootUrl, v2ClientOptions);

const routeProposalsApi =
	apiClient.v2.api[":siteId"]["road-ai"]["route-proposals"];

/** 受付リクエストの本文（v2-server のスキーマから型を導出する）。 */
export type RoadAiRouteProposalBody = InferRequestType<
	(typeof routeProposalsApi)["$post"]
>["json"];

/** 受付（202）。経路生成は非同期のため、返るのはジョブハンドルと使用アセット。 */
export const postRoadAiRouteProposal = (
	siteId: string,
	body: RoadAiRouteProposalBody,
): Promise<Response> =>
	routeProposalsApi.$post({ param: { siteId }, json: body });

/** ジョブ照会（1 回）。ポーリングの制御は roadAiPolling が担う。 */
export const fetchRoadAiJob = (
	siteId: string,
	jobHandle: RoadAiJobHandle,
): Promise<Response> =>
	routeProposalsApi[":jobHandle"].$get({ param: { siteId, jobHandle } });
